import { Link } from "react-router-dom";

const LINKS = [
  { label: "Privacy Policy", to: "/privacy" },
  { label: "Terms of Service", to: "/terms" },
  { label: "Accessibility", to: "/accessibility" },
];

export default function Footer({ variant = "app" }) {
  const marketing = variant === "marketing";
  const year = new Date().getFullYear();
  const wrap = marketing
    ? "relative z-20 border-t border-white/10 text-white/50"
    : "border-t border-border text-muted-foreground";
  const link = marketing
    ? "text-white/60 hover:text-white"
    : "hover:text-foreground";
  return (
    <footer className={wrap} role="contentinfo" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8 py-8 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-xs text-center sm:text-left" data-testid="footer-copyright">
          © {year} PM LaunchPad AI. All Rights Reserved.
        </p>
        <nav aria-label="Footer" className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs">
          {LINKS.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`footer-link-${l.to.slice(1)}`}
              className={`rounded transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-volt focus-visible:ring-offset-2 ${link}`}
            >
              {l.label}
            </Link>
          ))}
          <a
            href="mailto:support@pmlaunchpadai.com"
            data-testid="footer-contact-support"
            className={`rounded transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-volt focus-visible:ring-offset-2 ${link}`}
          >
            Contact Support
          </a>
        </nav>
      </div>
    </footer>
  );
}
